import React, { useState, useEffect } from 'react'

export default function Medarbejdere() {
  const [pageData, setPage] = useState(null)
  const [employees, setEmployees] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Set metadata
    document.title = "Medarbejdere - Frejlev Auto v/ Jacob Kvist"
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute('content', "Mød medarbejderne hos Frejlev Auto v/ Jacob Kvist. Vi har mange års erfaring og står klar til at hjælpe dig.")
    }

    // Fetch page content and employees in parallel
    Promise.all([
      fetch('https://api.dev.auxo.dk/public/by-slug/da/medarbejdere').then(res => res.json()),
      fetch('https://api.dev.auxo.dk/public/content/employees').then(res => res.json())
    ])
      .then(([page, empList]) => {
        setPage(page)
        if (Array.isArray(empList)) {
          setEmployees(empList)
        }
        setLoading(false)
      })
      .catch(err => {
        console.error('Error fetching medarbejdere content:', err)
        setLoading(false)
      })
  }, [])

  return (
    <div className="min-h-screen bg-gray-50 py-12 md:py-20 text-gray-900">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Breadcrumbs */}
        <div className="text-xs text-gray-500 uppercase tracking-wider mb-6 flex items-center gap-2">
          <span>Forside</span>
          <i className="fa-solid fa-chevron-right text-[8px]"></i>
          <span className="text-[#5cbe4f] font-semibold">Medarbejdere</span>
        </div>

        {loading ? (
          <div className="space-y-8 animate-pulse">
            <div className="h-10 bg-gray-200 rounded w-1/2"></div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              <div className="h-80 bg-gray-200 rounded-xl"></div>
              <div className="h-80 bg-gray-200 rounded-xl"></div>
            </div>
          </div>
        ) : pageData ? (
          <div className="space-y-10">
            {/* Header Card */}
            <div className="bg-white p-6 sm:p-10 rounded-2xl border border-gray-200 shadow-sm space-y-6">
              <div className="space-y-3">
                <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-950 tracking-tight">
                  {pageData.title.split('|')[0].trim()}
                </h1>
                <div className="h-1 w-20 bg-[#5cbe4f] rounded"></div>
              </div>

              {/* Description */}
              <div 
                className="rich-text"
                dangerouslySetInnerHTML={{ 
                  __html: pageData.content.replace(/<h1[^>]*>.*?<\/h1>/i, '') 
                }}
              />
            </div>

            {/* Employees Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {employees.map((emp) => (
                <div key={emp.id} className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm group hover:shadow-md transition-shadow">
                  {/* Employee Image */}
                  <div className="aspect-square overflow-hidden relative bg-gray-100">
                    <img
                      src={`https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/${emp.image[0].replace('https://assets.auxodev.dk/', '')}`}
                      alt={emp.name}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>

                  {/* Employee Details */}
                  <div className="p-6 space-y-1 text-center border-t border-gray-100">
                    <h3 className="text-xl font-bold text-gray-900 group-hover:text-[#5cbe4f] transition-colors">
                      {emp.name}
                    </h3>
                    <p className="text-[#5cbe4f] text-xs uppercase tracking-wider font-bold">
                      {emp.role}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="text-center py-12">
            <p className="text-gray-500">Kunne ikke indlæse indholdet. Prøv igen senere.</p>
          </div>
        )}
      </div>
    </div>
  )
}
